/* Argus Studio — live previews for the badge and key holder builders */
(function () {
  var STYLES = {
    italic:  { family: 'Chakra Petch, sans-serif', weight: '700', fstyle: 'italic', skew: 'skewX(-10)', track: 3, scale: 1 },
    wide:    { family: 'Michroma, sans-serif',     weight: '400', fstyle: 'normal', skew: '',           track: 6, scale: 0.72 },
    outline: { family: 'Chakra Petch, sans-serif', weight: '700', fstyle: 'normal', skew: '',           track: 4, scale: 1 }
  };

  function checked(form, name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el || null;
  }

  function initBadge(root) {
    var form = root.querySelector('form');
    var svg = root.querySelector('[data-badge-svg]');
    if (!form || !svg) return;
    var text = svg.querySelector('[data-badge-text]');
    var panel = svg.querySelector('[data-panel]');
    var line = svg.querySelector('[data-panel-line]');
    var plate = svg.querySelector('[data-plate]');
    var bar = svg.querySelector('[data-bar]');
    var label = root.querySelector('[data-preview-label]');
    var input = form.querySelector('[data-badge-input]');
    var accent = getComputedStyle(document.documentElement).getPropertyValue('--accent').trim() || '#E8B04B';

    function render() {
      var styleEl = checked(form, 'properties[Letter style]');
      var finEl = checked(form, 'properties[Finish]');
      var plEl = checked(form, 'properties[Placement]');
      var styleId = styleEl ? styleEl.dataset.id : 'italic';
      var st = STYLES[styleId] || STYLES.italic;
      var hex = finEl ? finEl.dataset.hex : '#D7262E';
      var finId = finEl ? finEl.dataset.id : 'red';
      var pl = plEl ? plEl.dataset.id : 'trunk';

      var raw = (input.value || '').toUpperCase().slice(0, 12);
      var shown = raw.trim() ? raw : 'YOUR TEXT';
      var len = Math.max(shown.length, 4);
      var base = pl === 'fender' ? 64 : 92;
      var size = Math.round(Math.min(base, (520 / len) * 1.45) * st.scale);
      var w = Math.min(560, len * size * (styleId === 'wide' ? 0.95 : 0.62));
      var outline = styleId === 'outline';
      var black = finId === 'black';

      text.textContent = shown;
      text.setAttribute('font-family', st.family);
      text.setAttribute('font-weight', st.weight);
      text.setAttribute('font-style', st.fstyle);
      text.setAttribute('font-size', size);
      text.setAttribute('letter-spacing', st.track);
      if (st.skew) text.setAttribute('transform', st.skew); else text.removeAttribute('transform');
      text.setAttribute('fill', outline ? 'none' : hex);
      text.setAttribute('stroke', outline ? hex : (black ? '#8E929A' : 'none'));
      text.setAttribute('stroke-width', outline ? 3 : (black ? 1.5 : 0));

      panel.setAttribute('fill', pl === 'grille' ? 'url(#argus-bmesh)' : (pl === 'trunk' ? '#2A2D32' : '#3A3E45'));
      var ly = pl === 'trunk' ? 70 : (pl === 'fender' ? 250 : -10);
      line.setAttribute('y1', ly); line.setAttribute('y2', ly);
      plate.setAttribute('opacity', pl === 'grille' ? 1 : 0);
      plate.setAttribute('x', 320 - (w + 60) / 2);
      plate.setAttribute('width', w + 60);
      bar.setAttribute('x', 320 - w / 2);
      bar.setAttribute('width', w);
      bar.setAttribute('y', 160 + size * 0.55);
      bar.setAttribute('fill', styleId === 'italic' ? accent : 'transparent');

      if (label) {
        label.textContent = (plEl ? plEl.value : '') + ' · ' + (styleEl ? styleEl.value : '') + ' · ' + (finEl ? finEl.value : '');
      }
      root.querySelectorAll('[data-finish-label]').forEach(function (n) { n.textContent = finEl ? finEl.value : ''; });
    }

    input.addEventListener('input', function () {
      var pos = input.selectionStart;
      input.value = input.value.toUpperCase();
      try { input.setSelectionRange(pos, pos); } catch (e) {}
      render();
    });
    form.addEventListener('change', render);
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); input.setAttribute('aria-invalid', 'true'); }
    });
    render();
  }

  function initKeys(root) {
    var form = root.querySelector('form');
    var svg = root.querySelector('[data-keys-svg]');
    if (!form || !svg) return;
    var hooksRow = root.querySelector('[data-hooks]');
    var firstHook = hooksRow && hooksRow.firstElementChild ? hooksRow.firstElementChild.outerHTML : '';
    var summary = root.querySelector('[data-keys-summary]');

    function setAll(sel, attr, val) { svg.querySelectorAll(sel).forEach(function (n) { n.setAttribute(attr, val); }); }
    function setText(sel, val) { root.querySelectorAll(sel).forEach(function (n) { n.textContent = val; }); }

    function render() {
      var b = checked(form, 'properties[Car color]');
      var e = checked(form, 'properties[Badge color]');
      var l = checked(form, 'properties[Headlight color]');
      var h = checked(form, 'properties[Key hooks]');
      if (b) {
        var d = b.dataset;
        setAll('[data-holder]', 'fill', d.hex);
        setAll('[data-holder]', 'stroke', d.edge);
        setAll('[data-holder-edge]', 'stroke', d.edge);
        setAll('[data-mesh]', 'fill', d.mesh);
        setAll('[data-mesh]', 'stroke', d.meshs);
        setAll('[data-grille]', 'stroke', d.grille);
        setAll('[data-light-edge]', 'stroke', d.edge);
        setText('[data-body-label]', b.value);
      }
      if (e) {
        setAll('[data-emblem]', 'stroke', e.dataset.hex);
        setText('[data-badge-color-label]', e.value);
      }
      if (l) {
        setAll('[data-light-line]', 'stroke', l.dataset.hex);
        setText('[data-light-label]', l.value);
      }
      if (h && hooksRow && firstHook) {
        var n = parseInt(h.dataset.count, 10) || 4;
        hooksRow.innerHTML = new Array(n + 1).join(firstHook);
      }
      if (summary) {
        summary.textContent = [b && b.value + ' car', e && e.value + ' badge', l && l.value + ' lights', h && h.value].filter(Boolean).join(' · ');
      }
    }
    form.addEventListener('change', render);
    render();
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    document.querySelectorAll('[data-badge-builder]').forEach(initBadge);
    document.querySelectorAll('[data-keys-builder]').forEach(initKeys);
  });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-badge-builder]').forEach(initBadge);
    e.target.querySelectorAll('[data-keys-builder]').forEach(initKeys);
  });
})();
